import { Component, OnInit } from '@angular/core';
import { EventsModel } from '../../models/events';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import * as momentHijri from 'moment-hijri';
import { EventsService } from '../../services/events-services';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';


@Component({
  selector: 'app-get-event-details',
  templateUrl: './get-event-details.component.html',
  styleUrls: ['./get-event-details.component.scss'],
})
export class GetEventDetailsComponent implements OnInit {
  model = {} as EventsModel;
  constructor(private route: Router,
     private diag: NbDialogRef<GetEventDetailsComponent>,
     public sanitizer: DomSanitizer,
    public service: EventsService) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }
  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close() {
    this.diag.close();
  }
  downloadFile(fileName) {
    this.service.downloadFile(fileName).subscribe((blob) => {
      downloadFileUtil(blob, fileName);
    });
  }
   getHijriDate(date) {
      return momentHijri(date, 'YYYY-MM-DD').format('iYYYY/iM/iD');
    }
}
